<template>
    <div id="Admin">
        <div class="admin_content">
            <div @click="this.close_admin()" class="admin_close"><i class="fas fa-times"></i></div>

            <div class="admin_login" v-if="this.is_logged_in === false">
                <div class="admin_login_box">
                    <div class="col-12 admin_login_title">Admin</div>
                    <div class="col-12 admin_error_log" v-if="this.error_log != ''">
                        {{this.error_log}}
                    </div>
                    <div class="col-12 admin_login_nip_box">
                        <div><button class="btn_number" @click="set_password('1')">1</button></div>
                        <div><button class="btn_number" @click="set_password('2')">2</button></div>
                        <div><button class="btn_number" @click="set_password('3')">3</button></div>
                        <div><button class="btn_number" @click="set_password('4')">4</button></div>
                        <div><button class="btn_number" @click="set_password('5')">5</button></div>
                        <div><button class="btn_number" @click="set_password('6')">6</button></div>
                        <div><button class="btn_number" @click="set_password('7')">7</button></div>
                        <div><button class="btn_number" @click="set_password('8')">8</button></div>
                        <div><button class="btn_number" @click="set_password('9')">9</button></div>
                        <div><button class="btn_number" @click="set_password('0')">0</button></div>
                    </div>
                    <div class="col-12" v-show="false">
                        <input type="password" name="admin_login" id="admin_login" ref="admin_login" value="">
                    </div>
                    <div class="col-12 text-center mt-3">
                        <button type="button" class="btn_connect" @click="this.valid_login()">Connecter</button>
                    </div>
                </div>
            </div>

            <div class="admin_reload" v-if="this.is_logged_in === true">
                <button @click="this.reload()" type="button" class="btn btn-light-primary text-uppercase align-middle btn-footer">
                    Relancer la borne
                </button>&nbsp;
                <button @click="this.show_achat_box()" type="button" class="btn btn-light-primary text-uppercase align-middle btn-footer">
                    Derniers achats
                </button>&nbsp;
                <button @click="this.show_config_box()" type="button" class="btn btn-light-primary text-uppercase align-middle btn-footer">
                    Configurations
                </button>
            </div>

            <div class="admin_achat" v-if="this.is_logged_in === true && this.show_achat === true">
                <h2>Derniers achats</h2>

                <div class="admin_achat_box">
                    <div v-if="this.$root.previous_order.length <= 0">Aucun achat enregistré!</div>
                    <div class="col-12 admin_achat_item" v-for="(invoice, index) in this.$root.previous_order">
                        <div class="admin_achat_item_box p-3 m-3">
                            <div class="d-flex align-items-center w-100">
                                <div class="col-6">Date achat</div>
                                <div class="col-6 text-end">{{this.timestamps_convert(invoice["original"]["data"]["invoices"][0]["created"],'date_and_time')}}</div>
                            </div>

                            <div class="d-flex align-items-center w-100">
                                <div class="col-6">Montant</div>
                                <div class="col-6 text-end">{{invoice["original"]["data"]["total"]}}$</div>
                            </div>

                            <div class="d-flex align-items-center w-100">
                                <div class="col-6">Nb billets</div>
                                <div class="col-6 text-end">{{invoice["original"]["data"]["cart_items"].length}}</div>
                            </div>

                            <div class="d-flex align-items-center w-100 mt-4">
                                <div class="col-12 text-center">
                                    <button @click="this.print_invoice(index)" type="button" class="btn btn-light-primary text-uppercase align-middle btn-footer">
                                        Imprimer
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="admin_configuration" v-if="this.is_logged_in === true && this.show_configuration === true">
                <h2>Configurations</h2>
                <div class="admin_configuration_box">
                    <div class="col-6">
                        TPV de cette borne
                    </div>
                    <div class="col-6 text-end">
                        <select name="tpv" ref="tpv">
                            <option value="">Sélectionner un tpv</option>
                            <option v-for="(tpv, index) in this.tpvlist" :value="index" :selected="index === this.$root.current_tpv">{{tpv}}</option>
                        </select>
                    </div>

                    <div class="col-12 text-end mt-3">
                        <button @click="this.save_configuration()" type="button" class="btn btn-light-primary text-uppercase align-middle btn-footer">
                            Enregistrer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import {defineComponent, ref, watch} from "vue";
import InvoiceTemplate1 from "../invoices/template1";
import {callAPI} from "../../helpers/kiosk-helpers";

export default defineComponent({
    name: "AdminHome",


    created() {
        window.addEventListener('keypress', this.onKeyPress);
    },

    beforeDestroy() {
        window.removeEventListener('keypress', this.onKeyPress);
    },

    data() {
        return {
            is_logged_in:false,
            error_log:"",
            show_configuration: false,
            show_achat: true,
            tpvlist:[],
            key_up: '',
        }
    },

    methods: {
        reload()
        {
            window.location.href = this.$root.borne_url;
        },

        onKeyPress(e) {
            if(e.key === 'Enter')
            {
                let code = this.key_up;
                this.valid_login(code);
                this.key_up = '';
            }
            else {
                console.log(e.key);
                this.key_up += e.key;
            }
        },

        clear_cache()
        {
            this.deleteAllCookies();
            localStorage.clear();
        },

        deleteAllCookies() {
            var cookies = document.cookie.split(";");

            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i];
                var eqPos = cookie.indexOf("=");
                var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
        },

        timestamps_convert(timestamps,format = 'date')
        {
            var date = new Date(timestamps * 1000);
            var year = date.getFullYear();
            var month = date.getMonth()+1;
            if(month < 10)
            {
                month = "0"+month;
            }
            var day = date.getDate();
            if(day < 10)
            {
                day = "0"+day;
            }
            var hour = date.getHours();
            if(hour < 10)
            {
                hour = "0"+hour;
            }
            var min = date.getMinutes();
            if(min < 10)
            {
                min = "0"+min;
            }

            if(format == 'date_and_time')
            {
                return year+"-"+month+"-"+day+ " " +hour+"H"+min;
            }
            return year+"-"+month+"-"+day;
        },

        print_invoice(index)
        {
            this.$root.invoice = this.$root.previous_order[index];
            this.$root.invoice_loaded = true;
        },

        close_admin()
        {
            window.removeEventListener('keypress', this.onKeyPress);
            this.$root.admin_invoice_loaded = false;
            this.$root.admin_show = false;
        },

        valid_login(code = '')
        {
            console.log(code);
            if(code === '')
            {
                code = this.$refs.admin_login.value;
            }

            return new window.Promise((resolve, reject) => {
                callAPI(route('api.store-access-tokens.pin.validate'), { token: this.$root.access_token, store_id: this.$root.store_id, pin: code}, 'post')
                    .then(response => {
                        if(response['data']['success'] === 1)
                        {
                            this.error_log = "";
                            this.is_logged_in = true;
                        }
                        else {
                            this.$refs.admin_login.value = '';
                            this.error_log = "Invalide!";
                        }
                        resolve(response);
                    })
                    .catch(error => {
                        this.$root.addErrors('a-402',null,String(error));
                        reject(error);
                    });
            });
/*
            if(this.$refs.admin_login.value === "5456")
            {
                this.error_log = "";
                this.is_logged_in = true;
            }
            else {
                this.$refs.admin_login.value = '';
                this.error_log = "Invalide!";
            }
            */

        },

        show_config_box()
        {
            this.show_achat = false;
            this.show_configuration = true;
        },

        show_achat_box()
        {
            this.show_configuration = false;
            this.show_achat = true;
        },

        save_configuration()
        {
            if(this.$refs.tpv.value !== "")
            {
                localStorage.setItem('BorneTpv_uid', this.$refs.tpv.value);
                this.$root.current_tpv = this.$refs.tpv.value;
                this.toastr.success('Enregistré avec succès.');
            }
            else {
                this.toastr.error('Le champs tpv est vide!');
            }
        },
        set_password(value)
        {
            this.$refs.admin_login.value = this.$refs.admin_login.value+''+value;
        },

        get_tpv_list()
        {
            return new window.Promise((resolve, reject) => {
                callAPI(route('api.kiosk.get.tpv.list'), { store_id: this.$root.store_id}, 'post')
                    .then(response => {
                        if(response['data']['success'] === 1)
                        {
                            this.tpvlist = response['data']['hardware_devices_json'];
                        }
                        resolve(response);
                    })
                    .catch(error => {
                        this.$root.addErrors('a-201',null,String(error));
                        reject(error);
                    });
            });
        },

        init()
        {

            this.get_tpv_list();

            this.$nextTick(() => this.$refs.admin_login.focus());
        },

    },



    mounted() {
        this.init();
    },


});
</script>
